import React from 'react';
import EnterpriseIconWHITE from '../../../static/images/Enterprise-Icon-WHITE.svg';
import BasicCalloutWrapper from '../../../shared/components/BasicCalloutWrapper/BasicCalloutWrapper';

const contactRepLink = 'https://www.flightstats.com/company/contact/contact-a-representative-about-flightstats-business-subscriptions/';

const NeedABusinessAccount = () => (
  <BasicCalloutWrapper
    openNewTab
    bulletText={['Minimum 10 users']}
    buttonLabel='Contact a representative'
    icon={EnterpriseIconWHITE}
    onClickGALabel='Contact a Rep'
    onClickURL={contactRepLink}
    subText='Talk to our representatives to get your account today!'
    titleText='Need a Business Account?'
  />
);

export default NeedABusinessAccount;



// WEBPACK FOOTER //
// ./shared/components/NeedABusinessAccount/NeedABusinessAccount.js